import { Link } from 'react-router-dom';

/**
 * Navy 4-column marketing footer. Uses the light wordmark on the dark ground.
 * Label set avoids "The moat" as a nav-style label (per product decision) —
 * the moat is the homepage centerpiece section, not a destination.
 */
export default function MarketingFooter() {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-grid">
          <div className="footer-col">
            <img src="/clarid-logo-light.png" alt="clarid.ai" className="footer-logo" />
            <p
              style={{
                color: 'rgba(243,241,234,0.55)',
                fontSize: '0.9rem',
                marginTop: '1.2rem',
                maxWidth: '30ch',
                lineHeight: 1.6,
              }}
            >
              The AI-native compliance operating system for community banks and credit unions.
            </p>
            <p className="meta" style={{ marginTop: '1.4rem', color: 'rgba(243,241,234,0.4)' }}>
              Built by a community banker · Validated by former FDIC and Federal Reserve examiners
            </p>
          </div>
          <div className="footer-col">
            <h4>Platform</h4>
            <ul>
              <li>
                <Link to="/#platform">How it works</Link>
              </li>
              <li>
                <Link to="/#outcomes">Outcomes</Link>
              </li>
              <li>
                <Link to="/features">Features</Link>
              </li>
              <li>
                <Link to="/pricing">Pricing</Link>
              </li>
            </ul>
          </div>
          <div className="footer-col">
            <h4>Modules</h4>
            <ul>
              <li>
                <Link to="/features">HMDA &amp; fair lending</Link>
              </li>
              <li>
                <Link to="/features">CRA &amp; regression</Link>
              </li>
              <li>
                <Link to="/features">Marketing compliance</Link>
              </li>
              <li>
                <Link to="/features">Exam center</Link>
              </li>
            </ul>
          </div>
          <div className="footer-col">
            <h4>Company</h4>
            <ul>
              <li>
                <Link to="/request-demo">Request a demo</Link>
              </li>
              <li>
                <Link to="/security">Security</Link>
              </li>
              <li>
                <Link to="/contact">Contact</Link>
              </li>
              <li>
                <Link to="/privacy">Privacy</Link>
              </li>
            </ul>
          </div>
        </div>
        <hr className="rule" style={{ borderColor: 'rgba(243,241,234,0.14)', marginTop: '3rem' }} />
        <p className="meta" style={{ marginTop: '1.6rem', color: 'rgba(243,241,234,0.4)' }}>
          © 2026 Clarid, Inc. · All rights reserved · clarid.ai
        </p>
      </div>
    </footer>
  );
}
